export default __webpack_public_path__ + "static/media/12.dccd99a5.jpg";